/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject12
     */
    aktid: number;
    /**
     * 
     * @type {string | number}
     * @memberof InlineObject12
     */
    alarmtime: string | number;
}

export function InlineObject12FromJSON(json: any): InlineObject12 {
    return InlineObject12FromJSONTyped(json, false);
}

export function InlineObject12FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject12 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'alarmtime': json['alarmtime'],
    };
}

export function InlineObject12ToJSON(value?: InlineObject12 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'alarmtime': value.alarmtime,
    };
}


